
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.86371 8.00449L8.52033 1.35368C9.25724 0.617426 10.3313 0.329884 11.3379 0.599373C12.3445 0.868862 13.1308 1.65444 13.4005 2.66019C13.6703 3.66594 13.3825 4.73905 12.6456 5.47531L5.98894 12.1573C5.91135 12.2343 5.81402 12.2883 5.70767 12.3135L1.26992 13.5H1.11366C0.922358 13.4965 0.743186 13.4057 0.627411 13.2535C0.511636 13.1013 0.472013 12.9045 0.519879 12.7194L1.70745 8.28551C1.73265 8.17926 1.78673 8.08201 1.86371 8.00449ZM8.42342 3.22187L3.17313 8.43636L5.54826 10.8094L10.7673 5.56371L8.42342 3.22187ZM2.62816 9.65687L4.31576 11.343L2.00312 11.9675L2.62816 9.65687ZM11.6745 4.6949L11.7683 4.57001C12.187 4.15168 12.3505 3.54195 12.1972 2.9705C12.044 2.39906 11.5972 1.95271 11.0253 1.79959C10.4533 1.64647 9.84308 1.80984 9.42438 2.22817L9.29937 2.32185L11.6745 4.6949Z"}})])
          )
        }
      }
    